import React, { useState } from 'react';
import { Alert, Box, Button, CircularProgress, Grid, Paper, TextField } from '@mui/material';
import 'date-fns';

import { getAssignmentDistance, getAssignmentPricing } from '../../repositories/HttpRepository';
import { useStyles } from './styles';

export default function AssignmentPricing() {
  const { classes } = useStyles();
  const [message, setMessage] = useState(null);
  const [assignmentId, setAssignmentId] = useState('');
  const [shipmentIds, setShipmentIds] = useState('');
  const [pricingData, setPricingData] = useState(null);
  const [distanceData, setDistanceData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loadingDistance, setLoadingDistance] = useState(false);

  const getAssignmentPricingData = () => {
    setLoading(true);
    // process shipmentIds
    let ids = [];
    const payload = {
      assignment_id: assignmentId,
    };
    if (shipmentIds) {
      const arr = shipmentIds.split(/[^\d]+/);
      ids = arr
        .map((id) => id.trim())
        .filter((id) => id !== '')
        .map((id) => parseInt(id, 10));

      payload['shipment_ids'] = ids;
    }

    getAssignmentPricing(payload).then((resp) => {
      // console.log('resp', resp);
      setLoading(false);
      if (resp.ok) {
        setPricingData(resp.data);
      }
    });
  };

  const getAssignmentDistanceData = () => {
    setLoadingDistance(true);
    // process shipmentIds
    let ids = [];
    const payload = {
      assignment_id: assignmentId,
    };
    if (shipmentIds) {
      const arr = shipmentIds.split(/[^\d]+/);
      ids = arr
        .map((id) => id.trim())
        .filter((id) => id !== '')
        .map((id) => parseInt(id, 10));

      payload['shipment_ids'] = ids;
    }

    getAssignmentDistance(assignmentId, payload).then((resp) => {
      setLoadingDistance(false);
      if (resp.ok) {
        setDistanceData(resp.data);
      }
    });
  };

  return (
    <Box sx={{ p: 3 }}>
      <form>
        <Box sx={{ pb: 3 }}>
          <Grid container spacing={3}>
            <Grid size={6}>
              <TextField id="assignment-ids" label="Assignment Ids" type="text" value={assignmentId} onChange={(e) => setAssignmentId(e.target.value)} />
            </Grid>
            <Grid size={6}>
              <TextField id="shipment-ids" fullWidth multiline label="Shipment Ids" type="text" value={shipmentIds} onChange={(e) => setShipmentIds(e.target.value)} />
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            <Grid size={3}>
              <Box>
                <div className={classes.wrapper}>
                  <Button variant="contained" color="primary" className={classes.buttonSuccess} disabled={loading} onClick={getAssignmentPricingData}>
                    Load Price Info
                  </Button>
                  {loading && <CircularProgress size={24} className={classes.buttonProgress} />}
                </div>
              </Box>
            </Grid>
            <Grid size={3}>
              <Box>
                <div className={classes.wrapper}>
                  <Button variant="contained" color="primary" className={classes.buttonSuccess} disabled={loadingDistance} onClick={getAssignmentDistanceData}>
                    Load Distance Info
                  </Button>
                  {loading && <CircularProgress size={24} className={classes.buttonProgress} />}
                </div>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </form>
      {message && <Alert severity="success">{message}</Alert>}
      {pricingData && (
        <Paper>
          <Box sx={{ p: 3 }}>
            <Box>
              <strong>New Cost: </strong>${pricingData.pricing.tour_cost}
            </Box>
          </Box>
          <Box sx={{ p: 3, display: 'flex', flexDirection: 'row' }}>
            <Box sx={{ pr: 2 }}>
              <strong>Old Cost: </strong>${pricingData.origin.tour_cost}
            </Box>
            <Box sx={{ pr: 2 }}>
              <strong>No Of Shipmentst: </strong>
              {pricingData.no_of_shipment}
            </Box>
            <Box sx={{ pr: 2 }}>
              <strong>Pickup Succeeded: </strong>
              {pricingData.pickup_succeeded}
            </Box>
            <Box sx={{ pr: 2 }}>
              <strong>Pickup Failed: </strong>
              {pricingData.pickup_failed}
            </Box>
            <Box sx={{ pr: 2 }}>
              <strong>Pickup Pending: </strong>
              {pricingData.pickup_pending}
            </Box>
          </Box>
        </Paper>
      )}
      {distanceData && (
        <Paper>
          <Box sx={{ p: 3 }}>
            <Box>
              <strong>Calculated Distance: </strong>
              {distanceData.distance} (m)
            </Box>
            <Box>
              <strong>Current Distance: </strong>
              {distanceData.old_distance} (m)
            </Box>
          </Box>
        </Paper>
      )}
    </Box>
  );
}
